import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OrgCropStages, ScreenHeader } from "react-library";
import { Routes } from "../../routes";
import { getAccessToken } from "../../services/common.service";
import { t, TLang } from "../../services/locale.service";
import { CropSownObj, CropStagesObject } from "stencil-library";

export type CropStageDetails = {
  cropStagesArr: Array<CropStagesObject>,
  crop: string,
  activeStgIndx: number,
  isSeasonEnded: boolean,
  cropSownDetails: CropSownObj
}

const OrgCropStageDetailContainer: React.FC = () => {
  const navigate = useNavigate();
  const { plotId, orgId } = useParams();
  const token = getAccessToken();
  const language = localStorage.getItem("user_language") as TLang;

  const headerTitle = t("Crop_Stage_Details");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    window.addEventListener("crop-season-ended", handleCropSeasonEnding);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
      window.addEventListener("crop-season-ended", handleCropSeasonEnding);
    };
  }, []);

  const handleCropSeasonEnding = () => {
    try {
      navigate(Routes.orgHome.replace(":orgId", orgId!));
    } catch (error) {
      console.log(error);
    }
  };

 
  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  return (
    <div>
      <ScreenHeader screenName={headerTitle}/>
      <OrgCropStages
        plotId={plotId}
        token={token}
        language={language ?? "en"}
      />
    </div>
  );
};

export default OrgCropStageDetailContainer;